/**
 * Generated runtime TestId mirror for frontend/src/components/attributes/SqlEditorDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const SqlEditorDialogTestIds = {
  btnRunQuery: "btn-run-query",
  sqlEditorApply: "sql-editor-apply",
  sqlEditorDialog: "sql-editor-dialog",
  sqlParametersHint: "sql-parameters-hint",
  sqlValidationError: "sql-validation-error"
} as const;
